function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.111 6H2.89C2.398 6 2 6.298 2 6.667v10.666c0 .369.398.667.889.667H17.11c.491 0 .889-.299.889-.667V6.667c0-.369-.398-.667-.889-.667zM18 6H2c-.552 0-1-.124-1-.278V1.278C1 1.124 1.448 1 2 1h16c.552 0 1 .124 1 .278v4.444c0 .154-.448.278-1 .278zM7 10h6",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgFilingBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    fill: "none"
  }, props), _ref);
}
export default SvgFilingBox;